<script setup lang="ts">
type TProps = {
  title?: string;
};

type TSlots = {
  headerSection?: () => unknown;
  content?: () => unknown;
  default?: () => unknown;
};

const props = defineProps<TProps>();
defineSlots<TSlots>();
</script>

<template>
  <section>
    <header class="flex items-center justify-between">
      <div class="whitespace-nowrap pr-6 text-primary-lighter">
        {{ props.title }}
      </div>
      <slot name="headerSection" />
    </header>
    <hr class="bg-white w-full h-px opacity-50 my-4" />
    <slot name="content" />
    <slot name="default" />
  </section>
</template>
